import { useEffect, useId } from "react";

// Globaler Guard für ungespeicherte Änderungen: Seiten (Training wie Admin)
// registrieren eine Warnung, Navigations-Handler (Layout, AdminLayout,
// Back-Buttons) fragen vor dem Verlassen per confirmLeaveIfGuarded() nach.
// Mehrere gleichzeitig offene Guards sind erlaubt – der zuletzt registrierte
// gewinnt, damit ein Modal-Guard über dem Seiten-Guard liegen kann.
const activeMessages = new Map<string, string>();

export const UNSAVED_CHANGES_MESSAGE =
  "Es gibt ungespeicherte Änderungen. Wenn du die Seite jetzt verlässt, gehen sie verloren.";

function currentMessage(): string | null {
  let last: string | null = null;
  activeMessages.forEach(message => { last = message; });
  return last;
}

export function confirmLeaveIfGuarded(): boolean {
  const message = currentMessage();
  if (message === null) return true;
  return window.confirm(message);
}

export function useLeaveWarning(active: boolean, message: string) {
  const id = useId();
  useEffect(() => {
    if (!active) return;
    activeMessages.set(id, message);
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = message;
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      activeMessages.delete(id);
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [active, message, id]);
}

/** Kurzform für Formulare: warnt beim Verlassen, solange ungespeicherte Änderungen offen sind. */
export function useUnsavedChangesWarning(dirty: boolean, message: string = UNSAVED_CHANGES_MESSAGE) {
  useLeaveWarning(dirty, message);
}
